"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const enums_1 = require("../enums");
class ProfilePriority extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        example: enums_1.Priority.HIGH_VALUE_RENEWABLE_WITH_CHURN_RISK,
        description: 'An indicator of the customer phase, churn risk and acquisition score.',
    }),
    (0, class_validator_1.IsIn)(Object.values(enums_1.Priority)),
    tslib_1.__metadata("design:type", String)
], ProfilePriority.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, base_models_1.Docs)({ example: 0, description: 'Order of priority, starting at 0.' }),
    tslib_1.__metadata("design:type", Number)
], ProfilePriority.prototype, "order", void 0);
exports.default = ProfilePriority;
